import { render, staticRenderFns } from "./RosterBlock.vue?vue&type=template&id=1a6bd918"
import script from "./RosterBlock.vue?vue&type=script&lang=ts"
export * from "./RosterBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports